<template>
  <div class="engine-card result-card">
    <div class="engine-card-title">胁迫识别结果</div>
    <div class="stress-list">
      <div v-for="item in stressList" :key="item.text">
        <i :class="{ high: item.level === '高' }">{{ item.level }}</i>
        <span v-html="item.text"></span>
      </div>
    </div>
  </div>
</template>

<script setup>
const stressList = [
  { level: "低", text: "水分胁迫<br />低，土壤墒情适宜" },
  { level: "低", text: "病虫风险<br />低，需雨后复查" },
  { level: "高", text: "光照适宜度<br />高，利于干物质积累" },
];
</script>

<style lang="less" scoped>
.engine-card {
  position: relative;
  min-width: 0;
  border: 2px solid rgba(57, 255, 238, 0.72);
  background:
    linear-gradient(180deg, rgba(0, 98, 85, 0.22), rgba(0, 38, 36, 0.58)),
    rgba(4, 45, 42, 0.72);
  box-shadow:
    inset 0 0 34px rgba(33, 255, 233, 0.13),
    0 0 22px rgba(33, 255, 233, 0.08);
  box-sizing: border-box;
}

.engine-card::before,
.engine-card::after {
  content: "";
  position: absolute;
  width: 82px;
  height: 34px;
  border-color: #30fff0;
  border-style: solid;
  pointer-events: none;
}

.engine-card::before {
  left: -2px;
  top: -2px;
  border-width: 2px 0 0 2px;
}

.engine-card::after {
  right: -2px;
  bottom: -2px;
  border-width: 0 2px 2px 0;
}

.engine-card-title {
  width: 300px;
  height: 58px;
  margin: 24px auto 0;
  color: #ffffff;
  font-size: 32px;
  font-weight: bold;
  line-height: 58px;
  text-align: center;
  background: linear-gradient(90deg, transparent, rgba(27, 180, 158, 0.76), transparent);
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.32);
}

.result-card {
  height: 632px;
  padding: 0 36px 34px;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.stress-list {
  height: calc(100% - 94px);
  display: grid;
  grid-template-rows: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 18px 22px;
  box-sizing: border-box;
  border: 1px solid rgba(62, 255, 238, 0.38);
  background: rgba(0, 62, 56, 0.34);
}

.stress-list div {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 22px;
  align-items: center;
  text-align: left;
}

.stress-list i {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 25px;
  font-style: normal;
  font-weight: bold;
  background: radial-gradient(circle, #36e8d6, #087b76);
  box-shadow: 0 0 18px rgba(54, 232, 214, 0.32);
}

.stress-list i.high {
  background: radial-gradient(circle, #30fff0, #058079);
}

.stress-list span {
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
  line-height: 34px;
}
</style>
